import state from './StockMove/states'
import mutations from './StockMove/mutations'
import actions from './StockMove/actions'
import getters from './StockMove/getters'

// 共通
const Store = {
  namespaced: true,
  state,
  mutations,
  actions,
  getters
}

export default Store
